import {Injectable, Injector} from "@angular/core";
import {ReportError} from "app/app.service";

import {BaseListService} from "app/services/domain/base.service";
import {UsersService} from "app/services/domain/users.service";
import {WorkloadDefinitionExtended} from "app/services/domain/workload-definitions.service";
import * as Models from "app/services/proxy/model/models";
import {AuditLogListRequest} from "app/services/proxy/model/models";

@Injectable()
export class AuditLogService extends BaseListService<Models.AuditLogListRequest, Models.BatchRequest, Models.AuditLogDocument>
{
    constructor(inj: Injector)
    {
        super(inj, Models.AuditLogDocument);
    }

    @ReportError
    public list(listReq: Models.AuditLogListRequest): Promise<Models.ListResponse>
    {
        return this.domain.apis.auditLog.auditLogList(listReq);
    }


    @ReportError
    protected async getBatchResponseImpl(req: Models.BatchRequest): Promise<Models.AuditLogBatchResponse>
    {
        const recordIdBatchRequest = Models.RecordIdentityBatchRequest.newInstance({ids: req?.ids.map((id) => WorkloadDefinitionExtended.newIdentity(id))});
        return this.domain.apis.auditLog.auditLogBatch(recordIdBatchRequest);
    }

    protected createBatchRequest(): Models.BatchRequest
    {
        return Models.BatchRequest.newInstance({ids: []});
    }
}
